class AliansPopup {

  constructor() {

  }

  init() {


    const popupTrigger = document.querySelectorAll('.popup-trigger');
    const popupSelector = document.querySelectorAll('.alians-popup');
    const exits = document.querySelectorAll('.alians-popup__exit');

    if (popupSelector)
    {
      exits.forEach((element, index) =>
      {
        element.setAttribute('data-popup', 'popup-' + index);
      });

      popupTrigger.forEach((element, index) =>
      {
        element.setAttribute('data-popup', 'popup-' + index);
      });

      popupSelector.forEach((element, index) =>
      {
        element.setAttribute('id', 'popup-' + index);
      });

      popupTrigger.forEach(function (btn)
      {
        btn.addEventListener('click', function ()
        {
          let popup = btn.getAttribute('data-popup');
          document.getElementById(popup).classList.toggle('active');
        })
      })


      exits.forEach(function (btn) {
        btn.addEventListener('click', function ()
        {
          let popup = btn.getAttribute('data-popup');
          document.getElementById(popup).classList.toggle('active');
        })
      })


      window.addEventListener('keydown', (e) =>
      {
        if (e.key === 'Escape') {
          popupSelector.forEach((element) =>
          {
            if (element.classList.contains('active')) {
              let popup = element.getAttribute('id');
              document.getElementById(popup).classList.remove('active');
            }
          });
        }
      })

      window.addEventListener('click', (e) => {

        if (e.target.id.includes('popup') && e.target.classList.contains('active')) {
          e.target.classList.remove('active')
        }
      })
    }
  }
}

export default new AliansPopup();
